<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title" *ngIf="title !== ''">{{ title }}</div>
    <img class="line" *ngIf="title !== ''" src="assets/img/lobby/ellipse.svg">
    <div class="list-container" *ngIf="list.length > 0 ; else object">
        <div class="list-item clickable" *ngFor="let item of list" (click)="changeSelected(item)">
            <div class="sopo-popup-text">{{ listText !== '' ? item + ' ' + listText : item}}</div>
            <img class="selected-item" src="assets/icon/tick.svg" *ngIf="item === selected"/>
        </div>
    </div>
</div>

<ng-template #object>
    <div class="list-container">
        <div class="list-item clickable" *ngFor="let item of listObject" (click)="changeSelected(item.value)">
            <div class="sopo-popup-text">{{ item.text }}</div>
            <img class="selected-item" src="assets/icon/tick.svg" *ngIf="item.value === selected"/>
        </div>
    </div>
</ng-template>